// extracted by mini-css-extract-plugin
export default {"header":"secondHeader_header__xSFRj","logo":"secondHeader_logo__0icBB"};